import React, { useState } from 'react'
import { GrClose } from "react-icons/gr";
import Layout from '../layout/Mainlayout'
import Games from '../data/games.json'
import Peshbiniakan from '../data/peshbibiakan.json';
import { useSelector } from 'react-redux'
import Loginreq from '../components/Loginreq';
import Gift from '../components/Gift';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import Peshbinibka from '../components/Peshbinibka';








export default function Peshbinikrdn() {




    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;

    const hours = current.getHours()
    const minutes = current.getMinutes()
    const time = `${hours}:${minutes}`



    console.log(time)

    const user = useSelector((state) => state.user)

    const game = []



    Games.map((team, index) => {

        return (
            team.date === date ? (
                <>

                    {game.push(team)}

                </>
            )
                :
                (
                    null
                )

        )

    })


    const [close, setClose] = useState(null)
    const [peshbini, setPeshbini] = useState(null)
    function CLOSE(team) {
        setClose(
            <div className='md:right-14 fixed md:top-10 top-4 right-4 z-50'>
                <button onClick={() => { setPeshbini(null); setClose(null); }}>
                    <GrClose className='w-10 h-10  mx-auto rounded-full p-2 bg-red-400' />
                </button>
            </div>
        )
    }




    

    




    

    return (
        <>

            {
                user.isAuthed ?
                    (
                        <Layout>
                        <div className='min-h-screen bg-dwam'>

                            {close}
                            {peshbini}

                            <Gift />
                            <div className=' bg-chwaram  items-center'>
                                <p className='text-3xl bg-dwam text-center p-5 text-shasham'>پێشبی بکە بۆ یارییەکانی ئەمڕۆ</p>
                                <Carousel
                                    showArrows={true}
                                    infiniteLoop={true}
                                    autoPlay={true}
                                    interval={4000}
                                    showIndicators={true}
                                    showThumbs={false}
                                    showStatus={false}
                                >
                                    {game.map((team) => {

                                        return (
                                            team.date === date ? (
                                                <>

                                                    <div className='flex flex-col h-fit  items-center md:items-end w-full p-1 md:p-10 mx-auto'>
                                                        <div className='space-y-3 mx-auto text-chwaram'>

                                                            <h1 className='text-yakam text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                                            <div className='flex flex-row space-x-4 mx-auto'>

                                                                <div className='bg-seyam text-yakam rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                                                <div className='bg-seyam text-yakam rounded-lg flex flex-col justify-center px-4 '>{team.time}</div>
                                                                <div className='bg-seyam text-yakam rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                                            </div>
                                                            

                                                            <div className='text-center'>
                                                                <button onClick={() => {
                                                                    setPeshbini(<Peshbinibka index={team.id} />); CLOSE(team); 
                                                                }} type='submit' className="shadow-sm shadow-penjam relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 w-1/3 overflow-hidden text-sm font-medium text-chwaram rounded-lg group bg-gradient-to-br from-penjam to-chwaram group-hover:from-penjam group-hover:to-chwaram hover:text-black  focus:ring-4 focus:outline-none focus:ring-green-200 ">
                                                                    <span className="shadow-sm shadow-penjam relative w-full px-2 py-1 transition-all ease-in duration-75 bg-yakam  rounded-md group-hover:bg-opacity-0">
                                                                        پێشبی بکە
                                                                    </span>
                                                                </button>
                                                            </div>

                                                            

                                                        </div>
                                                    </div>

                                                </>
                                            )
                                                :
                                                (
                                                    null
                                                )

                                        )

                                    })}

                                </Carousel>
                            </div>
                            <div className='bg-dwam  p-1 flex flex-col md:flex-row-reverse justify-between w-full'>




                                <div className='md:p-6 w-full md:w-1/2'>
                                    <h1 className='text-center text-3xl p-1 border-b-2 border-yakam text-shasham'>پێشبینیەکانت</h1>
                                    <div>

                                        {Peshbiniakan.map((peshbini) => {

                                            if (user.userName === peshbini.username) {

                                                return (
                                                    <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full p-1 md:p-3 mx-auto'>
                                                        <div className='space-y-3 mx-auto text-chwaram'>

                                                            <h1 className=' text-center'>{peshbini.gametype}</h1>
                                                            <div className='flex flex-row space-x-4 mx-auto'>

                                                                <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'> <img src={peshbini.logot1} alt={peshbini.logot1} /> <p>{peshbini.team1}</p></div>
                                                                <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>{peshbini.peshT1} - {peshbini.peshT2}</div>
                                                                <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'>  <p>{peshbini.team2}</p><img src={peshbini.logot2} alt={peshbini.logot2} /></div>

                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            else {
                                                return (
                                                    null
                                                )
                                            }

                                        })}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Layout>
                    )
                    :
                    (
                        <Loginreq />
                    )
            }
        </>


    )
}
